<template>
  <div>
    <ul class="detalhamento-cirurgia">
      <li>
        Sua cirurgia está
        <span class="status">{{ cirurgia.StatusCirurgia }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'StatusContent',
  props: {
    cirurgia: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
.status {
  color: var(--green);
  text-transform: uppercase;
}

ul.detalhamento-cirurgia {
  list-style: circle;
  text-align: left;
  padding-left: 25px;
  li {
    margin-bottom: 5px;
  }
  a {
    color: var(--blue);
    text-decoration: underline;
  }
}
</style>
